import { Box, Collapse, Icon, List, ListItemButton, Tooltip, Typography } from '@mui/material'
import classNames from 'classnames'
import i18n from 'i18next'
import React, { ReactElement, useState } from 'react'
import { useLocation } from 'react-router'
import { SubMenu } from 'ui/components/Navigation/types'
import SidebarItem from '../SidebarItem/SidebarItem'
import styles from './SubMenuItem.module.less'

const defaultLanguage = 'en'
const subMenuItemContentSx = { display: 'flex', alignItems: 'center', width: '100%', minWidth: 0 }
const subMenuItemLeftContentSx = { display: 'flex', alignItems: 'center', minWidth: 0, flexGrow: 1 }
const subMenuItemIconContainerSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  minWidth: 24,
}
const subMenuItemLabelSx = { minWidth: 0, flex: 1, display: 'block' }

type SubMenuItemProps = {
  item: SubMenu
  sideBarOpen: boolean
  onNavigate?: () => void
}

export default function SubMenuItem({ item, sideBarOpen, onNavigate }: SubMenuItemProps): ReactElement {
  const lang = localStorage.getItem('language') ?? i18n.language ?? defaultLanguage
  const location = useLocation()
  const [expanded, setExpanded] = useState(false)

  return (
    <>
      <li>
        <ListItemButton
          sx={{
            pl: 2,
            pr: sideBarOpen ? 2 : 0.75,
          }}
          classes={{
            root: classNames(styles.SubMenuItem_ListItem, {
              [styles.SubMenuItem_ActiveNested]: item.children.find((child) => {
                return child.path === location.pathname
              }),
            }),
          }}
          onClick={() => setExpanded(!expanded)}
        >
          <Tooltip arrow placement="right" title={sideBarOpen ? `` : item.sidebarName}>
            <Box sx={subMenuItemContentSx}>
              <Box sx={subMenuItemLeftContentSx}>
                <Box sx={subMenuItemIconContainerSx}>
                  <Box className={styles.SubMenuItem_Text}>
                    {typeof item.icon === `string` ? <Icon className={item.icon} /> : <item.icon />}
                  </Box>
                </Box>
                {sideBarOpen ? (
                  <Box sx={{ ml: 2, minWidth: 0, flexGrow: 1 }}>
                    <Typography lang={lang} sx={subMenuItemLabelSx} className={styles.SubMenuItem_Label} variant="h5">
                      {item.sidebarName}
                    </Typography>
                  </Box>
                ) : null}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 20,
                  minWidth: 20,
                  flexShrink: 0,
                  ml: sideBarOpen ? 2 : 1.5,
                }}
              >
                <Icon
                  style={{ color: `white` }}
                  fontSize="inherit"
                  className={classNames(styles.SubMenuItem_SubMenuIcon, `fal fa-chevron-right`, {
                    [styles.SubMenuItem_SubMenuIconOpen]: expanded,
                  })}
                />
              </Box>
            </Box>
          </Tooltip>
        </ListItemButton>
      </li>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {item.children.map((module, i) => {
            return (
              <SidebarItem
                item={module}
                key={item.sidebarName + i}
                active={module.path === location.pathname}
                sideBarOpen={sideBarOpen}
                nested
                onNavigate={onNavigate}
              />
            )
          })}
        </List>
      </Collapse>
    </>
  )
}
